import React, { useState } from 'react'

import Button from 'components_new/atoms/Button'
import Icon from 'components_new/atoms/Icon'
import Skeleton from 'components_new/atoms/Skeleton'

import AddToGroupDialog from '../dialogs/AddToGroupDialog'

import { useAccountSettings } from 'redux/hooks/SignedInAccount'
import { useGroup } from 'redux/hooks/Groups'
import { useTranslation } from 'language/translator'

interface GroupAddMemberButtonProps {
  id: string
  sx?: object
}

const GroupAddMemberButton = (props: GroupAddMemberButtonProps) => {
  const { id, sx } = props
  const [dialogOpen, setDialogOpen] = useState<boolean>(false)

  const { t } = useTranslation()
  const { loading: accountLoading } = useAccountSettings()
  const group = useGroup(id)

  if (accountLoading || !group) {
    return <Skeleton height={32} variant="rounded" width={96} />
  }

  return (
    <>
      <Button
        onClick={() => setDialogOpen(true)}
        startIcon={<Icon name="GroupAddOutlined" />}
        sx={sx}
      >
        {t('global', 'invite')}
      </Button>

      <AddToGroupDialog
        id={id}
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
      />
    </>
  )
}

export default GroupAddMemberButton
